import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/ui/assets/images/Principal.webp'
import _imports_1 from '@/ui/assets/images/logo.webp'


const _hoisted_1 = { class: "landing-content" }
const _hoisted_2 = { class: "landing-section" }
const _hoisted_3 = { class: "landing-text" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", { style: {"color":"#00D4FF"} }, "Estamos para ayudarte", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createTextVNode("¿Tienes problemas para "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-underline" }, "entender el mercado"),
  /*#__PURE__*/_createTextVNode(" de la publicidad digital?")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("El Mercado de la publicidad online es incierto y complejo, Admetricks te "),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#00D4FF"} }, "ayuda a visibilizar cómo desempeñan las campañas y contenidos"),
  /*#__PURE__*/_createTextVNode(" versus los de tu competencia en tiempo real con reportes y alertas automáticas")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "landing-img-wrapper" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Imagen principal",
    class: "landing-img-main"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "Imagen de fondo",
    class: "landing-img-bg"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ServiesSection = _resolveComponent("ServiesSection")!
  const _component_DollarChart = _resolveComponent("DollarChart")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("header", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        _createElementVNode("button", {
          class: "landing-btn",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleDollarChartVisibility && _ctx.toggleDollarChartVisibility(...args)))
        }, "Solicitar demo"),
        _createElementVNode("span", {
          class: "span-header",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleDollarChartVisibility && _ctx.toggleDollarChartVisibility(...args)))
        }, " Ver funcionalidades ")
      ]),
      _hoisted_7
    ]),
    _createVNode(_component_ServiesSection),
    (_ctx.showDollarChart)
      ? (_openBlock(), _createBlock(_component_DollarChart, {
          key: 0,
          onClose: _ctx.toggleDollarChartVisibility
        }, null, 8, ["onClose"]))
      : _createCommentVNode("", true)
  ]))
}